import React from 'react';
import PropTypes from 'prop-types';
import { Container } from '@mui/material';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import dayjs from 'dayjs';
import 'dayjs/locale/es-mx';
import EventBanner from './EventBanner';
import EventResume from './EventResume';

dayjs.extend(utc);
dayjs.extend(timezone);

function EventHeader({ event }) {
  const {
    event: { banner },
  } = event;

  return (
    <>
      <EventBanner banner={banner} />
      <Container>
        <EventResume event={event} />
      </Container>
    </>
  );
}

EventHeader.propTypes = {
  event: PropTypes.object.isRequired,
};

export default EventHeader;
